import { createClient } from '@supabase/supabase-js'

export const DEFAULT_SUPABASE_URL = 'https://spb-bp1189e3cdewfte7.supabase.opentrust.net'
export const DEFAULT_SUPABASE_ANON_KEY =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiYW5vbiIsInJlZiI6InNwYi1icDExODllM2NkZXdmdGU3IiwiaXNzIjoic3VwYWJhc2UiLCJpYXQiOjE3NzUwMzE2OTQsImV4cCI6MjA5MDYwNzY5NH0.Witdeq_-Fafmst8EG251pMdnKYdGDizXhvWthyt0xyk'

const isOriginalOrLocalHost = (() => {
  if (typeof window === 'undefined') return false

  const host = window.location.hostname
  return (
    host === '8td5idtyk6.ai-app.pub' ||
    host === 'localhost' ||
    host === '127.0.0.1'
  )
})()

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  (isOriginalOrLocalHost ? DEFAULT_SUPABASE_URL : '')
const supabaseKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  (window as any).__SUPABASE_ANON_KEY__ ||
  (isOriginalOrLocalHost ? DEFAULT_SUPABASE_ANON_KEY : '')

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseKey)

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.invalid',
  supabaseKey ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzAwMDAwMDAwLCJleHAiOjQxMDAwMDAwMDB9.placeholder-signature'
)

// Auth bootstrap helper
let authReadyPromise: Promise<void> | null = null

export function waitForSupabaseAuthReady() {
  if (!authReadyPromise) {
    authReadyPromise = (async () => {
      const { data } = await supabase.auth.getSession()
      if (data.session) return

      await new Promise<void>((resolve) => {
        const timeout = window.setTimeout(resolve, 1500)
        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
          if (session) {
            window.clearTimeout(timeout)
            subscription.unsubscribe()
            resolve()
          }
        })
      })
    })()
  }

  return authReadyPromise
}

;(window as any).supabase = supabase
